import * as classNames from 'classnames'
import * as React from 'react'
import InputWrapper from './InputWrapper'
import Select from 'react-select'
import { Field, FieldProps } from 'formik'

export interface IDropdownOption {
  label: string
  value: string
}

const Dropdown = (props: {
  name: string
  options: IDropdownOption[]
  defaultOption?: IDropdownOption | null
  placeholder?: string
}) => {
  const getSelect = (form: any) => {
    const handleSelect = (event: any) => {
      form.setFieldValue(props.name, event.value)
    }
    const selectedOption =
      props.defaultOption ||
      props.options.find(option => {
        return option.value === form.values[props.name]
      })

    return (
      <Select clearable={false} name={name} value={selectedOption} onChange={handleSelect} options={props.options} />
    )
  }

  return (
    <Field name={props.name}>
      {({ field, form }: FieldProps<any>) => <div className='mt1'>{getSelect(form)}</div>}
    </Field>
  )
}

export default Dropdown



// WEBPACK FOOTER //
// ./src/components/ui/Dropdown.tsx